import React from 'react'
import { useChargingConnectorTypes } from '@services/device'
import { Select, SelectProps } from '@shared/Form/Select'
import { useTranslation } from 'react-i18next'
import { pathOr } from 'ramda'

type Props = SelectProps & {
  showAll?: boolean
  filterItem?: any[]
  autoCompleteInput?: string
}

export const ChargingConnectorTypesSelect = React.forwardRef<
  typeof Select,
  Props
>((props, ref): any => {
  const { t } = useTranslation()

  const { dataSource, isLoading } = useChargingConnectorTypes()
  const _dataSource: any = dataSource

  return (
    <Select allowClear placeholder={'選擇接頭規格'} {...props}>
      {props?.showAll && (
        <Select.Option key="all" value="">
          {t('common:all')}
        </Select.Option>
      )}
      {(pathOr([], ['data'], _dataSource) || []).map((x: any) => (
        <Select.Option key={x} value={x}>
          {x}
        </Select.Option>
      ))}
    </Select>
  )
})

export default ChargingConnectorTypesSelect
